import { IContactGroup, IContactSet } from '../interfaces/contact.interfaces';

export function getContactsByLocation(contacts: IContactSet[]): IContactGroup[] {
	const contactsWithoutLocation: IContactGroup = {
		id: 'No Location',
		name: 'No Location',
		contacts: [],
	};
	const contactsByLocation: IContactGroup[] = contacts.reduce((acc, contact) => {
		if (!contact.location) {
			contactsWithoutLocation.contacts.push(contact);
			return acc;
		}
		const location = contact.location?.name;
		const locationId = contact.location?.locationId;
		const existingLocation = acc.find(group => group.id === locationId);
		if (existingLocation) {
			existingLocation.contacts.push(contact);
		} else {
			acc.push({
				id: locationId,
				name: location,
				contacts: [contact],
			});
		}

		return acc;
	}, []);

	return sortContactList(contactsByLocation, contactsWithoutLocation);
}

export function getContactsByCompany(contacts: IContactSet[]): IContactGroup[] {
	const contactsWithoutCopmany: IContactGroup = {
		id: 'No Company',
		name: 'No Company',
		contacts: [],
	};
	const contactsByCompany: IContactGroup[] = contacts.reduce((acc, contact) => {
		if (!contact.company) {
			contactsWithoutCopmany.contacts.push(contact);
			return acc;
		}
		const company = contact.company;
		const existingCompany = acc.find(group => group.name === company);

		if (existingCompany) {
			existingCompany.contacts.push(contact);
		} else {
			acc.push({
				id: company,
				name: company,
				contacts: [contact],
			});
		}

		return acc;
	}, []);

	return sortContactList(contactsByCompany, contactsWithoutCopmany);
}

export function getContactsByLabel(contacts: IContactSet[]): IContactGroup[] {
	const contactsWithoutLabel: IContactGroup = {
		id: 'No Label',
		name: 'No Label',
		contacts: [],
	};
	const contactsByLabel: IContactGroup[] = contacts.reduce((acc, contact) => {
		const labels = contact.labels || [];

		if (!labels.length) {
			contactsWithoutLabel.contacts.push(contact);

			return acc;
		}
		labels.forEach(label => {
			const existingLabel = acc.find(group => group.name === label.name);
			if (existingLabel) {
				existingLabel.contacts.push(contact);
			} else {
				acc.push({
					id: label.id,
					name: label.name,
					contacts: [contact],
					label: label,
				});
			}
		});

		return acc;
	}, []);

	return sortContactList(contactsByLabel, contactsWithoutLabel);
}

export function groupContacts(contacts: IContactSet[], groupBy: string): IContactGroup[] {
	switch (groupBy) {
		case 'location':
			return getContactsByLocation(contacts);
		case 'company':
			return getContactsByCompany(contacts);
		case 'labels':
			return getContactsByLabel(contacts);
		default:
			return [];
	}
}

function sortContactsGroups(contactgroups: IContactGroup[]) {
	return contactgroups
		.map(contactgroup => {
			return sortContacts(contactgroup);
		})
		.sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
}

function sortContacts(contactgroup: IContactGroup): IContactGroup {
	return {
		...contactgroup,
		contacts: contactgroup.contacts.sort((a, b) => {
			if (!a.firstName && !b.firstName) return 0;
			if (!a.firstName) return 1;
			if (!b.firstName) return -1;
			return a.firstName.localeCompare(b.firstName);
		}),
	};
}

function sortContactList(
	groupedContacts: IContactGroup[],
	contactsWithoutGroup: IContactGroup
): IContactGroup[] {
	return contactsWithoutGroup.contacts.length > 0
		? [...sortContactsGroups(groupedContacts), sortContacts(contactsWithoutGroup)]
		: sortContactsGroups(groupedContacts);
}
